<template>
  <div id="app">
    <router-view name="header" />
    <div class="wrapper">
      <div class="content">
        <router-view />
      </div>
    </div>
    <router-view name="footer" />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Oswald');
  @import url('https://fonts.googleapis.com/css?family=Montserrat');

  @font-face {
    font-family: BebasNeue;
    src: url('/fonts/bebas-neue.ttf');
  }

  * {
    margin: 0;
    padding: 0;
    border: none;
    font-size: 100%;
    outline: none;
  }

  html, body {
    max-width: 100%;
    overflow-x: hidden;
  }

  html {
    box-sizing: border-box;
  }

  body {
    &.menu-is-open {
      position: fixed;
      top: 0;
      overflow-y: hidden;
    }
  }

  #app {
    font-family: BebasNeue, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
